import { useState, useEffect } from 'react';

const useCountUp = (endValue, duration = 4000) => {
  const [count, setCount] = useState(0);
  const stepTime = 20; // Atualiza a cada 20ms para uma animação suave

  useEffect(() => {
    // Só inicia a animação se o valor final for um número válido e maior que zero
    if (typeof endValue !== 'number' || endValue <= 0) {
      setCount(endValue || 0);
      return;
    }
    
    let startTime = null;
    let animationFrameId = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      
      // Easing function (easeOutQuad) para a animação começar rápido e desacelerar no final
      const easedPercentage = percentage * (2 - percentage);
      const currentValue = Math.floor(easedPercentage * endValue);
      
      setCount(currentValue);

      if (progress < duration) {
        animationFrameId = requestAnimationFrame(animate);
      } else {
        setCount(endValue); // Garante que o valor final seja exato
      }
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [endValue, duration]);

  return count;
};

export default useCountUp;